module.exports = __webpack_public_path__ + "assets/images/project/previous.svg?v=9c597803";